import Link from 'next/link'

/** Breadcrumb visivo (il JSON-LD BreadcrumbList è generato a parte nei builder SEO). */
export function Breadcrumb({ items, className = '' }: { items: { name: string; href?: string }[]; className?: string }) {
  return (
    <nav aria-label="Breadcrumb" className={`flex flex-wrap items-center gap-1.5 text-sm text-zinc-500 ${className}`}>
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-1.5">
          {it.href ? (
            <Link href={it.href} className="transition-colors hover:text-accent-strong">
              {it.name}
            </Link>
          ) : (
            <span className="line-clamp-1 text-zinc-700">{it.name}</span>
          )}
          {i < items.length - 1 ? <span aria-hidden className="text-zinc-300">/</span> : null}
        </span>
      ))}
    </nav>
  )
}
